import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

/*
    We maintain a list of most recently used 5 tables by storing the tablesId in the MRU list.
    Whenever a new table is added to the MRU, we subscribe to the row notifications.
    Whenever a table id entry is removed from the MRU we unsubscribe to the row notifications.
    This means at any time only 5 tables are active\live.
*/
let tableIdList: string[];
let capacity: number = 5;
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
let onAdd: (tableView: TableView) => any;
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
let onRemove: (tableViewId: string) => any;

function add(tableView: TableView) {
    tableIdList.unshift(tableView.id);
    onAdd(tableView);
    invalidateOldEntries();
}

function bumpToFront(tableView: TableView) {
    const entry = tableView.id;
    tableIdList.splice(tableIdList.indexOf(entry), 1);
    tableIdList.unshift(entry);
}

function invalidateOldEntries() {
    if (tableIdList.length > capacity) {
        for (let i = capacity; i < tableIdList.length; i++) {
            onRemove(tableIdList[i]);
        }
        tableIdList.length = capacity;
    }
}

/**
 * Clear all the TableViews from the MRU list.
 * Call the onRemove callback on all the TableViews
 * Reset the tableIdList to an empty array.
 */
export function clearMruTableList() {
    tableIdList.forEach(onRemove);
    tableIdList = [];
    tableIdList.length = 0;
}

export function initialize(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    onAddCallback: (tableView: TableView) => any,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    onRemoveCallback: (tableViewId: string) => any,
    listCapacity: number
) {
    tableIdList = [];
    onAdd = onAddCallback;
    onRemove = onRemoveCallback;
    capacity = listCapacity;
}

export function update(tableView: TableView): number {
    let entryIndex = 0;
    if (tableIdList) {
        entryIndex = tableIdList.indexOf(tableView.id);

        switch (entryIndex) {
            case -1:
                add(tableView);
                break;
            case 0:
                break;
            default:
                bumpToFront(tableView);
        }
    }

    return entryIndex;
}
